module.exports = __webpack_public_path__ + "officialStatic/img/new25.bb0dd91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new25.jpg
// module id = +b91
// module chunks = 0